import { createApiRef } from '@backstage/core-plugin-api';
import { DefaultApiClient } from '@internal/plugin-confluent-common';

export const confluentApiRef = createApiRef<DefaultApiClient>({
  id: 'plugin.confluent.service',
});
